var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-item"},[_c('div',{staticClass:"item-name"},[_vm._v(_vm._s(_vm.period))]),_c('div',{staticClass:"item-value",class:_vm.selected,on:{"pointerdown":_vm.selectPeriod}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }